import { getClientStrategySchema } from "api/client-strategy-schema";

import { ClientStrategyCategoryDTOStrategyCategory } from "generated/schemas";

export type ProgramStrategyType = "a2a" | "a2e";

export type ProgramStrategySchemaParams = {
  programStrategyType: ProgramStrategyType;
  version?: number;
};

const PROGRAM_STRATEGY_TYPE_TO_CATEGORY: Record<
  ProgramStrategyType,
  ClientStrategyCategoryDTOStrategyCategory
> = {
  a2a: ClientStrategyCategoryDTOStrategyCategory.A2A_PROGRAM,
  a2e: ClientStrategyCategoryDTOStrategyCategory.A2E_PROGRAM,
};

export const getProgramStrategyCategory = (
  programStrategyType: ProgramStrategyType,
): ClientStrategyCategoryDTOStrategyCategory =>
  PROGRAM_STRATEGY_TYPE_TO_CATEGORY[programStrategyType];

export const getProgramStrategySchema = async ({
  programStrategyType,
}: ProgramStrategySchemaParams): Promise<unknown> =>
  getClientStrategySchema({
    strategyCategory: getProgramStrategyCategory(programStrategyType),
  });
